import { all, call, fork, put, takeEvery, select } from "redux-saga/effects";

import { favoritePlacesSelectSuccess } from "./actions";
import { authApiAccessCheck } from "../auth/actions";

import { FavoritePlacesGetBySubscriber } from "../../api-tasks/favorite-places";
import { FAVORITE_SELECT_REQUEST } from "../actions";

function* selectFavorite({payload}) {
    
    const state = yield select();
    const { history } = payload;
    try {
      const authUser = state.authUser;
      const user = authUser.user;
  
      const resultSet = yield call(FavoritePlacesGetBySubscriber, user.userToken);
      
      if (resultSet) {
        if (Array.isArray(resultSet)) {
          yield put(favoritePlacesSelectSuccess(resultSet));
        } else { 
            yield put(authApiAccessCheck(history, resultSet));
        }
      }
    } catch (error) {
      console.log("error vehicle saga 1 :", error);
    }
  }

  export function* watchSelectAllRequest() {
    yield takeEvery(FAVORITE_SELECT_REQUEST, selectFavorite);
  }

  export default function* rootSaga() {
    yield all([fork(watchSelectAllRequest)]);
  }
